export const SERVER_TIME_HEADER = 'X-Server-Time';

export interface ClockSample {
  offsetMs: number;
  rttMs: number;
  takenAtMs: number;
}

const SAMPLE_WINDOW_MS = 5 * 60_000;

export class ClockOffsetEstimator {
  private samples: ClockSample[] = [];

  observe(sentAtMs: number, serverMs: number, receivedAtMs: number): ClockSample | undefined {
    const rttMs = receivedAtMs - sentAtMs;
    if (!Number.isFinite(serverMs) || serverMs <= 0 || rttMs < 0) return undefined;

    const sample = { offsetMs: serverMs - (sentAtMs + receivedAtMs) / 2, rttMs, takenAtMs: receivedAtMs };
    this.samples = [...this.samples.filter((s) => receivedAtMs - s.takenAtMs < SAMPLE_WINDOW_MS), sample];

    return sample;
  }

  best(): ClockSample | undefined {
    return this.samples.reduce<ClockSample | undefined>(
      (best, s) => (best === undefined || s.rttMs < best.rttMs ? s : best),
      undefined,
    );
  }
}

export function sampleServerClockFromFetch(
  estimator: ClockOffsetEstimator,
  onNewBest: (sample: ClockSample) => void,
): void {
  const originalFetch = window.fetch;

  window.fetch = async (input, init) => {
    const sentAtMs = Date.now();
    const response = await originalFetch(input, init);
    const serverMs = Number(response.headers.get(SERVER_TIME_HEADER));

    const bestBefore = estimator.best();
    estimator.observe(sentAtMs, serverMs, Date.now());
    const bestAfter = estimator.best();
    if (bestAfter !== undefined && bestAfter !== bestBefore) onNewBest(bestAfter);

    return response;
  };
}
